import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: 'transparent',  // optional, just to give it a visual for this example
        padding: theme.spacing(2),  // some padding for visual comfort
    },
    child: {
        backgroundColor: '#FFF',
        borderRadius: 8
    }
}));

function CardContainer(props: { children: any }) {
    const classes = useStyles();
    let {children} = props;
    return (
        <Grid container justify="center" className={classes.root}>
            <Grid item xs={12} md={10} lg={8} className={classes.child}>
                {children}
            </Grid>
        </Grid>
    );
}

export default CardContainer;
